import ManageCourses from './ManageCourses';
export default ManageCourses;
